if (!customElements.get('topology-video')) {
  customElements.define('topology-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.wantsPlayback = !this.motion.matches;
      this.visible = false;
      this.video.muted = true;
      this.motion.addEventListener('change', () => {
        this.wantsPlayback = !this.motion.matches;
        this.syncPlayback();
      }, options);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.syncPlayback();
      }, { threshold: 0.1 });
      this.observer.observe(this);
    }

    syncPlayback() {
      if (this.wantsPlayback && this.visible && !document.hidden) {
        this.video.play().catch(() => {});
      } else {
        this.video.pause();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.video?.pause();
    }
  });
}
